import _ from "lodash-es";
import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import { CompanySpecialConfig } from "../exam/candidate-answer";
import Auth from "@/lib/common/auth";

export default class Company extends Model {
  id = "";
  name = "";
  companyType = ""; // 0-公司 、 1-集团
  logoUrl = "";
  nickname = "";
  isEnableAI = true; //定义类型变化 number -> 布尔
  role = "";
  roleName = "";
  departmentNo = "0";
  shortname = "";
  companyIcon = "";
  channelCode = "";
  aiExamVersionList = [""];

  //更新vuex存储的当前公司信息
  public static info(
    companyId: string,
    authHandleError = true
  ): Promise<Company> {
    return request
      .post(
        "interview/user/getCompany",
        {
          companyId: companyId,
          ucCompanyId: companyId
        },
        authHandleError
      )
      .then(async resp => {
        const company = new Company(resp).assign(resp.data.data);
        const vuexStore = import("@/store/vuex-store");
        vuexStore.then(module => {
          module.default.updateCompany(company);
        });
        try {
          await Company.updatePower();
        } catch (e) {
          console.error("updatePower:" + e);
        }
        return company;
      });
  }

  public static list(authHandleError = true) {
    return request
      .post("interview/user/getCompanyListNew", {}, authHandleError)
      .then(resp => {
        const companies = new Array<Company>();
        _.forEach(resp.data.data, item => {
          console.log(item);
          const company = new Company().assign(item);
          companies.push(company);
        });
        const vuexStore = import("@/store/vuex-store");
        vuexStore.then(module => {
          module.default.updateCompanies(companies);
        });
        return companies;
      });
  }
  public static async updatePower() {
    return request.post("/aiExam/company/get", {}).then(resp => {
      const power = new CompanySpecialConfig().assign(
        resp.data.data.companySpecialConfig
      );
      const vuexStore = import("@/store/vuex-store");
      vuexStore.then(module => {
        module.default.updateCompanyPower(power);
      });
    });
  }
}

export class RedirectConfig extends Model {
  companyId = Auth.companyId;
  content = "请点击下方按钮，在微信小程序面试";
  imgUrl = "";
  isClose = 1;
  title = "欢迎参加面试";
  isOutClose = 1;
  outUrl = "";
  outTitle = "跳转小程序";
  outAppId = "";

  static get() {
    return request
      .post("aiExam/redirectConfig/get", { companyId: Auth.companyId })
      .then(async res => {
        return res.data;
      });
  }

  static save(params: RedirectConfig) {
    return request
      .post("aiExam/redirectConfig/save", params)
      .then(async res => {
        return res.data;
      });
  }
}
